export { default } from './NewsSkeleton';
